/**
 * Describe locale data as follows
 */
// Variable name should match to the file name (without extension)!
const et = {
	// ISO language code 
	locale: 'et',
	// Language name in local language
	lang: 'Eesti',
	// Language name in English
	langEn: 'Estonian',
	// Translation table in form { engMessage: localLanguageMessage, ... }
	trans: {
		'Estonian': 'Eesti'
	}
};
export default et;
